import { AppNS } from 'app';
import { parseDate, UI_DATE_FORMAT_STRING } from 'app/ui_v2/helpers/parseDate';
import EmailIcon from 'app/ui_v2/icons/EmailIcon';
import PhoneIcon from 'app/ui_v2/icons/PhoneIcon';

import { Box, useTheme } from '@mui/material';

export interface ProfileInfoProps {
  profileData: AppNS.InspectorProfile;
}

export default function ProfileInfo(props: ProfileInfoProps) {
  const { profileData } = props;

  const theme = useTheme();

  return (
    <Box my={2} sx={{ display: 'flex', gap: 4 }}>
      <Box>
        <Box display="flex" alignItems="center" mb={1.5}>
          <EmailIcon />
          <Box sx={{ fontSize: '1.6rem', ml: 1 }}>{profileData.user.email}</Box>
        </Box>
        <Box display="flex" alignItems="center" mb={0.5}>
          <PhoneIcon />
          <Box sx={{ fontSize: '1.6rem', ml: 1 }}>{profileData.user.contactPhone}</Box>
        </Box>
      </Box>
      <Box sx={{ borderLeft: `1px solid ${theme.palette.divider}`, pl: 4 }}>
        {/* <Box display="flex" alignItems="center" mb={0.5}>
          <Box sx={{ fontSize: '1.6rem' }}>
            Inspector Health Score: <strong>92/100</strong>
          </Box>
        </Box> */}
        <Box sx={{ fontSize: '1.2rem' }}>
          Last updated at: <strong>{parseDate(profileData.updatedAt, UI_DATE_FORMAT_STRING)}</strong>
        </Box>
      </Box>
    </Box>
  );
}
